import { IMusicProductPhysicalSettlementInfoForm } from 'services/music-product-physical/types/form';
import { IMusicProductPhysicalSettlementInfoMutation } from 'services/music-product-physical/types/mutation';

export const settlementInfoFormToQuery = ({
  perTrackSettlement,
  contracts,
  perTrackContracts,
}: IMusicProductPhysicalSettlementInfoForm): IMusicProductPhysicalSettlementInfoMutation => ({
  perTrackSettlement,
  contracts: contracts.map(
    ({ contractId, divisionPercentage, startDate, endDate }) => ({
      contractId,
      divisionPercentage,
      startDate,
      endDate: endDate?.length ? endDate : null,
    })
  ),
  perTrackContracts: perTrackSettlement
    ? perTrackContracts
        .map(track =>
          track.contracts.map(
            ({ contractId, divisionPercentage, startDate, endDate }) => ({
              contractId,
              divisionPercentage,
              startDate,
              endDate: endDate?.length ? endDate : null,
              trackId: track.trackId,
            })
          )
        )
        .flat()
    : [],
});
